<script>
   /*****************************************************************/
   /* Axes                                                          */
   /* --------------------                                          */
   /* modified version of Axes for the apps                         */
   /*****************************************************************/

   import { XAxis, YAxis, Box, Axes } from 'svelte-plots-basic/2d';
   import { PNG_WIDTH, PNG_HEIGHT, PNG_RES, MARGINS } from './Defaults.js';

   let {
      title,                // JSON with main plot parameters
      limX,                 // JSON with plot series
      limY,                 // number of components selected by user
      xLabel,
      yLabel,
      whole = false,
      fileName,
      children,
      ...others
   } = $props();
</script>

<Axes {title} {limX} {limY} {fileName} downloadLinks="hover"
   margins={MARGINS} pngWidth={PNG_WIDTH} pngHeight={PNG_HEIGHT} pngRes={PNG_RES}
   {...others}
>
   {@render children()}
   <XAxis showGrid={true} label={xLabel} {whole} />
   <YAxis showGrid={true} label={yLabel} />
   <Box />
</Axes>
